<!-- Inner Banner -->
<div class="inner-banner inner-bg1">
    <div class="container">
        <div class="inner-title text-center">
            <h3>About Us</h3>
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li><i class='bx bxs-chevron-right'></i></li>
                <li>About Us</li>
            </ul>
        </div>
    </div>
</div>
<!-- Inner Banner End -->

<!-- About Area -->
<div class="about-area pt-100 pb-70">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="about-img about-img-before">
                    <img src="assets/img/about/about-img1.jpg" alt="Images">

                    <div class="about-img-small">
                        <img src="assets/img/about/about-img2.jpg" alt="Images">
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="about-content">
                    <span>About Us</span>
                    <h2>Your Trusted Accounting Partner
                    </h2>
                    <!-- <h2>We Are Standing With <b>30+</b> Years Of Experience</h2> -->
                    <!-- <h3>Trusted And Effective Business Consulting Service Provider </h3> -->
                    <!-- <p>Sed vel risus a sem cursus fermentum. Aliquam a fermentum velit. Sed varius nisl libero, at
                        tempor lectus mollis ullamcorper. Ut volutpat dignissim arcu sit amet finibus. Aenean pulvinar
                        ornare erat. Donec a massa sed ipsum fringilla rhoncus.</p>
                    <p>Dignissim arcu sit amet finibus.Aenean pulvinar ornare erat. Donec a massa sed ipsum fringilla
                        rhoncus.</p> -->
                    <p>With over 10 years of professional experience, our founder has built a reputation for trusted,
                        effective business consulting and accounting services. We provide personalized, strategic
                        solutions to help businesses thrive.</p>
                    <p>At My Professional Accountants, we pride ourselves on our client-centric approach, leveraging
                        extensive industry knowledge to guide businesses towards financial success. Our team has worked
                        with a diverse range of clients, including a major South African bank.</p>
                    <p>Our mission is to empower businesses with accurate financial insights and strategic advice,
                        ensuring compliance and optimizing financial performance.</p>

                    <!-- <div class="row">
                        <div class="col-lg-4 col-md-4 pr-0">
                            <div class="about-counter">
                                <i class="flaticon-medal"></i>
                                <div class="content">
                                    <h3>1200+</h3>
                                    <span>Award Winner</span>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-4 pr-0">
                            <div class="about-counter">
                                <i class="flaticon-team"></i>
                                <div class="content">
                                    <h3>10+</h3>
                                    <span>Years Experience</span>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-4 pr-0">
                            <div class="about-counter">
                                <i class="flaticon-briefcase"></i>
                                <div class="content">
                                    <h3>Trusted by</h3>
                                    <span>Leading South African Institutions</span>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <div class="about-btn">
                        <a routerLink="/contact" class="learn-btn">Get A Quote</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="about-polygon-shape">
        <img src="assets/img/shape/shape10.png" alt="Images">
    </div>
</div>
<!-- About Area End -->

<!-- Choose Area -->
<div class="choose-area-two choose-bg pt-100 pb-70">
    <div class="container">
        <div class="row">
            <div class="col-lg-7 col-md-12">
                <div class="choose-content choose-content-title">
                    <div class="section-title">
                        <h2>Your Trusted Partner for Comprehensive Accounting Solutions</h2>
                        <p>At My Professional Accountants, we are dedicated to providing personalized and strategic
                            financial solutions tailored to your business needs. Our expertise spans across company
                            registration, bookkeeping, tax planning, and financial consulting. Trust us to guide
                            your business towards sustainable growth and success with our commitment to excellence
                            and integrity.</p>
                        <!-- <a routerLink="/contact" class="book-btn">Get A Quote</a> -->
                    </div>

                    <div class="row border-top">
                        <div class="col-lg-6 col-sm-6">
                            <div class="choose-content-list">
                                <i class="flaticon-sort"></i>
                                <div class="content">
                                    <h3>Fast Service</h3>
                                    <p>Quick and efficient service to meet your accounting needs promptly and
                                        accurately.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-6 col-sm-6">
                            <div class="choose-content-list">
                                <i class="flaticon-briefcase"></i>
                                <div class="content">
                                    <h3>Easy to Contact</h3>
                                    <p>Always available to address your queries and provide timely support and
                                        advice.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-6 col-sm-6">
                            <div class="choose-content-list">
                                <i class="flaticon-analytics"></i>
                                <div class="content">
                                    <h3>Business Planning</h3>
                                    <p>Strategic business planning to guide your company towards sustainable growth
                                        and success.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-6 col-sm-6">
                            <div class="choose-content-list">
                                <i class="flaticon-chess-pieces"></i>
                                <div class="content">
                                    <h3>Experienced Team</h3>
                                    <p>Highly skilled professionals with extensive experience to ensure top-notch
                                        financial management and consulting.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-5 col-md-12">
                <div class="choose-img-2">
                    <img src="assets/img/choose/choose-img4.jpg" alt="Images">

                    <div class="choose-dots">
                        <img src="assets/img/choose/choose-dots.png" alt="Images">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Choose Area End -->

<!-- Client Area -->
<div class="client-area-two ptb-100">
    <div class="container">
        <div class="section-title text-center">
            <span>Clients Review</span>
            <h2>Our Valued Clients Share Their Success Stories</h2>
            <p>At My Professional Accountants, we take pride in our clients' achievements. Our personalized and
                strategic financial solutions have empowered businesses to reach new heights. Hear directly from those
                who have experienced our commitment to excellence and integrity.</p>
        </div>

        <div class="client-slider owl-carousel owl-theme pt-45">
            <div class="client-card">
                <h3>Dilshad Patel</h3>
                <span>CEO Of Pink Hijabi</span>
                <ul>
                    <li>
                        <i class='bx bxs-star'></i>
                        <i class='bx bxs-star'></i>
                        <i class='bx bxs-star'></i>
                        <i class='bx bxs-star'></i>
                        <i class='bx bxs-star'></i>
                    </li>
                </ul>
                <p>The team at My Professional Accountants is always available, offering insightful financial advice
                    tailored to our business needs.</p>
                <i class="flaticon-quote client-card-quote"></i>
                <!-- <div class="client-card-img">
                    <img src="assets/img/client/client-img1.png" alt="Images">
                </div> -->
            </div>

            <div class="client-card">
                <h3>Arsalan Ahmed</h3>
                <span>CEO Of My Guy Online Shopping</span>
                <ul>
                    <li>
                        <i class='bx bxs-star'></i>
                        <i class='bx bxs-star'></i>
                        <i class='bx bxs-star'></i>
                        <i class='bx bxs-star'></i>
                        <i class='bx bxs-star'></i>
                    </li>
                </ul>
                <p>My Professional Accountants has transformed our financial management. Their expertise and support
                    have been invaluable to our growth.</p>
                <i class="flaticon-quote client-card-quote"></i>
                <!-- <div class="client-card-img">
                    <img src="assets/img/client/client-img4.png" alt="Images">
                </div> -->
            </div>

            <div class="client-card">
                <h3>Nazeera</h3>
                <span>Manager at Albaraka Bank</span>
                <ul>
                    <li>
                        <i class='bx bxs-star'></i>
                        <i class='bx bxs-star'></i>
                        <i class='bx bxs-star'></i>
                        <i class='bx bxs-star'></i>
                        <i class='bx bxs-star'></i>
                    </li>
                </ul>
                <p>Their strategic analysis, planning and attention to detail helped us navigate complex financial
                    challenges with
                    remarkable ease.</p>
                <i class="flaticon-quote client-card-quote"></i>
                <!-- <div class="client-card-img">
                    <img src="assets/img/client/client-img3.png" alt="Images">
                </div> -->
            </div>

            <div class="client-card">
                <h3>Zain Abedin</h3>
                <span>COO at Cape Candy</span>
                <ul>
                    <li>
                        <i class='bx bxs-star'></i>
                        <i class='bx bxs-star'></i>
                        <i class='bx bxs-star'></i>
                        <i class='bx bxs-star'></i>
                        <i class='bx bxs-star'></i>
                    </li>
                </ul>
                <p>Exceptional service and dedication! They have been instrumental in streamlining our accounting
                    processes and ensuring compliance.</p>
                <i class="flaticon-quote client-card-quote"></i>
                <!-- <div class="client-card-img">
                    <img src="assets/img/client/client-img3.png" alt="Images">
                </div> -->
            </div>
        </div>
    </div>

    <div class="client-shape">
        <div class="shape1"><img src="assets/img/shape/shape8.png" alt="Images"></div>
        <div class="shape2"><img src="assets/img/shape/shape6.png" alt="Images"></div>
        <div class="shape3"><img src="assets/img/shape/shape11.png" alt="Images"></div>
    </div>
</div>
<!-- Client Area End -->

<!-- Leader Area -->
<div class="leader-area">
    <div class="container">
        <div class="leader-content">
            <div class="section-title text-center">
                <h2>Expand Your Reach and Lead Your Industry</h2>
                <p>Unlock your business potential with expert accounting services. Let us guide you to success.</p>
            </div>
        </div>
    </div>
</div>
<!-- Leader Area End -->

<!-- Contact Area -->
<div class="contact-area pb-100">
    <div class="container">
        <div class="contact-area-bg">
            <div class="row">
                <div class="col-lg-6 col-md-12">
                    <div class="contact-form">
                        <div class="section-title text-center">
                            <h2>Request a Consultation</h2>
                            <p>Contact us today for a personalized consultation. Discover how we can elevate your
                                business.</p>
                        </div>

                        <form id="contactForm">
                            <div class="row">
                                <div class="col-lg-6 col-sm-6">
                                    <div class="form-group">
                                        <input type="text" name="name" id="name" class="form-control" required
                                            placeholder="Name">
                                    </div>
                                </div>

                                <div class="col-lg-6 col-sm-6">
                                    <div class="form-group">
                                        <input type="email" name="email" id="email" class="form-control" required
                                            placeholder="Email">
                                    </div>
                                </div>

                                <div class="col-lg-6 col-sm-6">
                                    <div class="form-group">
                                        <input type="text" name="phone_number" id="phone_number" required
                                            class="form-control" placeholder="Phone">
                                    </div>
                                </div>

                                <div class="col-lg-6 col-sm-6">
                                    <div class="form-group">
                                        <input type="text" name="msg_subject" id="msg_subject" class="form-control"
                                            required placeholder="Your Subject">
                                    </div>
                                </div>

                                <div class="col-lg-12 col-md-12">
                                    <div class="form-group">
                                        <textarea name="message" class="form-control" id="message" cols="30" rows="8"
                                            required data-error="Write your message"></textarea>
                                    </div>
                                </div>

                                <div class="col-lg-12 col-md-12 text-center">
                                    <button type="submit" class="default-btn">Submit</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Contact Area End -->